function initShowMoreContainers() {
    const grids = document.querySelectorAll('.show-more-container');

    grids.forEach(grid => {
        const button = grid.querySelector('.show-more-button');
        if (!button) return;

        // Read group size from data attribute, fallback to 4
        const groupSizeAttr = grid.getAttribute('data-page-size');
        const groupSize = parseInt(groupSizeAttr, 10);
        const itemsToShowPerClick = isNaN(groupSize) || groupSize <= 0 ? 4 : groupSize;

        // Initial check: if no hidden items, remove the button right away
        const initialHiddenItems = grid.querySelectorAll('.show-more-item--hide');
        if (initialHiddenItems.length === 0) {
            button.remove();
            return;
        }

        //remove the u-hidden attribute on the button as we will need it
        //optional for a button to have one
        button.classList.remove('u-hidden');

        button.addEventListener('click', () => {
            const hiddenItems = grid.querySelectorAll('.show-more-item--hide');
            for (let i = 0; i < itemsToShowPerClick && i < hiddenItems.length; i++) {
                hiddenItems[i].classList.remove('show-more-item--hide');
            }

            // Remove button if there are no more hidden items
            const remainingHiddenItems = grid.querySelectorAll('.show-more-item--hide');
            if (remainingHiddenItems.length === 0) {
                button.remove();
            }
        });
    });
}

function initTableLoadMore() {
    const tables = document.querySelectorAll('.table-load-more');
    if (!tables.length) return;

    tables.forEach(tableEl => {
        try {
            const tableId  = tableEl.id;
            const rowsAttr = tableEl.getAttribute('tlm-rows');
            const rows     = parseInt(rowsAttr, 10) || 5;
            const tbody    = tableEl.querySelector('tbody');
            if (!tbody) return;

            const trs = Array.from(tbody.querySelectorAll('tr'));
            if (trs.length - 1 <= rows) {
                tableEl.classList.remove('u-hidden');
                return;
            }

            // Hide rows beyond the initial visible count
            trs.forEach((tr, i) => {
                if (i > rows) tr.classList.add('u-hidden');
            });

            // Build and append the footer with the Load More button
            const footId    = `${tableId}-foot`;
            const btnId     = `${tableId}-footbutton`;
            const remaining = trs.length - rows - 1;

            const tfoot = document.createElement('tfoot');
            tfoot.id        = footId;
            tfoot.innerHTML = `<tr><td></td><td colspan="99" class="footcell"><button id="${btnId}" aria-label="Load more" class="w100 btn btn--subtle u-txt-sm footbutton">Load More (${remaining})</button></td></tr>`;
            tableEl.appendChild(tfoot);

            tfoot.querySelector('button').addEventListener('click', () => {
                const allTrs   = Array.from(tableEl.querySelector('tbody').querySelectorAll('tr'));
                const unhidden = allTrs.filter(tr => !tr.classList.contains('u-hidden')).length;

                // Reveal the next batch
                allTrs.slice(unhidden, unhidden + rows).forEach(tr => tr.classList.remove('u-hidden'));

                const stillHidden = allTrs.filter(tr => tr.classList.contains('u-hidden')).length;
                if (stillHidden === 0) {
                    tfoot.remove();
                } else {
                    tfoot.querySelector('button').textContent = `Load More (${stillHidden})`;
                }
            });

            tableEl.classList.remove('u-hidden');
        } catch (e) {
            console.error(e);
        }
    });
}

function init() {
    initShowMoreContainers();
    initTableLoadMore();
}

export { init }
